export const savePreparationTimeAction = payload => ({
    type: 'SAVE_PREPARATION_TIME',
    payload
})